/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.repo.defs'

export { $nsid }

type CommitMeta = {
  $type?: 'com.atproto.repo.defs#commitMeta'
  cid: l.CidString
  rev: l.TidString
}

export type { CommitMeta }

const commitMeta = /*#__PURE__*/ l.typedObject<CommitMeta>(
  $nsid,
  'commitMeta',
  /*#__PURE__*/ l.object({
    cid: /*#__PURE__*/ l.string({ format: 'cid' }),
    rev: /*#__PURE__*/ l.string({ format: 'tid' }),
  }),
)

export { commitMeta }
